import React, { useEffect, useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import { myroutes } from "../../routes/webroute";
import { FiEye, FiEyeOff } from 'react-icons/fi';
import Swal from "sweetalert2";
// importation auth reducer 
import { loginUser,checkAuthenticate,resetAuthData  } from "../../app/providers/authSlice";
import { useDispatch, useSelector } from "react-redux";
//import RolesusersService from "../../services/RolesusersService";

export default function Login() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()  

    const isAuthenticate = useSelector(state => state.auth.isAuthenticate)

    const countPanier = useSelector(state => state.panier.countPanier)

    const auth = useSelector(state => state.auth)

    const dispatch = useDispatch()

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
      };

      const [showField, setShowField] = useState(false);

    
    //console.log(token)
    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loginRequest, setLoginRequest] = useState({email:'',password:''}) 
    //const [rolesusers, setRolesusers] = useState([]) 

    const [rememberMe, setRememberMe] = useState(false);

        const handleRememberMeChange = (e) => {
        setRememberMe(e.target.checked);
        };

 
    // end vérification de l'authentification
    dispatch(checkAuthenticate)
    if (isAuthenticate) {
        if (countPanier > 0) {

        // check if panier content data

        navigate(myroutes.commandes);

        } else {
             //check user role for specific redirection
      auth.roles?.includes("USER") ? navigate(myroutes.moncompte) : navigate(myroutes.dashboard)
 
        }
       
    }

    

    // change input data
    const onInputChange = (name,e) => {
        const val = (e.target && e.target.value) || '';
        let _formRequest = { ...loginRequest };
        _formRequest[`${name}`] = val;
        setLoginRequest(_formRequest);
    }

    const handleLogin = async (e) => {

        e.preventDefault()  

                // Sauvegarder les identifiants si "Se rappeler de moi" est coché
        if (rememberMe) {
            localStorage.setItem("email", email);
            localStorage.setItem("password", password);
        } else {
            // Si "Se rappeler de moi" n'est pas coché, supprimez les identifiants sauvegardés
            localStorage.removeItem("email");
            localStorage.removeItem("password");
        }
 
        await AuthService.login(loginRequest).then(({ data }) => { 
            
              // transmission des données au reducer
                dispatch(loginUser(data))
            

            // navigate("/statuts")
        }).catch(({ response }) => {   
            Swal.fire({
                icon: "error",
                text: response.data.erreur,
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                background: "red",
                color: "white",
                iconColor: "white"
            }) 
        })
    }


    useEffect(() => {
        // Vérifier si les identifiants sont sauvegardés dans le stockage local
        const savedEmail = localStorage.getItem("email");
        const savedPassword = localStorage.getItem("password");
      
        // Remplir automatiquement les champs du formulaire s'ils existent
        if (savedEmail) {
          setEmail(savedEmail);
        }
      
        if (savedPassword) {
          setPassword(savedPassword);
        }
      }, []);
      

    //##########################/// END METHODES ##########################///
    return (
        <React.Fragment>
            <div className="row g-0 app-auth-wrapper">
                <div className="col-12 col-md-7 col-lg-6 auth-main-col text-center p-5">
                    <div className="d-flex flex-column align-content-end">
                        <div className="app-auth-body mx-auto">
                            <div className="app-auth-branding mb-4"><a className="app-logo" href="/"><img className="logo-icon me-2" src="../startup/img/logo-digiweb.png" alt="logo" style={{ width: "150px", height: "150px" }} /></a></div>
                            <h2 className="auth-heading text-center mb-5">Authentification</h2>
                            <div className="auth-form-container text-start">
                                 
                                <form className="auth-form login-form" onSubmit={handleLogin}>
                                    <div className="email mb-3">
                                        <label className="sr-only" htmlFor="signin-email">Email</label>
                                        <input id="signin-email" value={loginRequest.email} minLength={5} maxLength={100} name="signin-email" onChange={(e) => onInputChange('email',e)} type="email" className="form-control signin-email border border-info" placeholder="Email" required="required" />
                                    </div>{/*//form-group*/}
                                    <div className="password mb-3">
                                    <label className="sr-only" htmlFor="signin-password">Mot de passe</label>
                                    <div className="input-group">
                                    <input
                                        id="signin-password"
                                        value={loginRequest.password}
                                        minLength={8}
                                        maxLength={50}
                                        name="signin-password"
                                        type={showPassword ? 'text' : 'password'}
                                        onChange={(e) => onInputChange('password', e)}
                                        className="form-control signin-password border border-info"
                                        placeholder="Mot de passe"
                                        required="required"
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle-button btn btn-outline-secondary"
                                        onClick={togglePasswordVisibility}
                                    >
                                        {showPassword ? <FiEyeOff /> : <FiEye />}
                                    </button>
                                    </div>
                                </div>{/*//form-group*/}
                                    <div className="text-center">
                                        <button  className="btn app-btn-primary bg-primary text-white w-100 theme-btn mx-auto">Se connecter</button>
                                    </div>
                                </form>
                                <div className="auth-option text-center pt-5">Pas de compte?</div>
                                <div className="auth-option text-center pt-2">S'inscrire en tant que  <Link className="text-link" to={myroutes.register} style={{ fontWeight: "bold" }} > Particulier ici</Link>.</div>
                                <div className="auth-option text-center pt-2"> S'inscrire en tant que <Link className="text-link" to={myroutes.register_entreprise} style={{ fontWeight: "bold" }} > Entreprise ici</Link>.</div>

                            </div>{/*//auth-form-container*/}

                        </div>{/*//auth-body*/}

                        <footer className="app-auth-footer">
                            <div className="container text-center py-3">
                                <small className="copyright">Conception réalisée par <span className="sr-only">love</span><i className="fas fa-heart" style={{ color: "#fb866a" }}></i> <a className="app-link" href="https://www.digiweb.bj/" target="_blank">Digiweb SARL</a> 2023</small>

                            </div>
                        </footer>{/*//app-auth-footer*/}
                    </div>{/*//flex-column*/}
                </div>{/*//auth-main-col*/}
                <div className="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
                    <div className=" auth-background-holder">
                    </div>
                    <div className="auth-background-mask">
                    </div>
                </div>

            </div>{/*//row*/}
        </React.Fragment>
    )
}